export const MINIMUM_CHART_DATE = '2000-01-01'

const enforceMinimumDate = (date: string | undefined, minDate = MINIMUM_CHART_DATE) =>
  !date || new Date(date) < new Date(minDate) ? minDate : date

export default enforceMinimumDate
